const company = {
  company: {
    pageHeader: 'Firmenprofil',
    branchProfile: 'Niederlassungsprofil',
    addBranchOffice: 'Niederlassung hinzufügen',
    companyDetails: 'Firmendetails',
    branchDetails: 'Niederlassungsdetails',
    companyName: 'Firma',
    branchName: 'Name der Niederlassung',
    websiteURL: 'Webadresse',
    url: 'URL',
    yearFounded: 'Gründungsjahr',
    companyLogo: 'Firmenlogo',
    imageFormatDescription: 'Erforderliches Dateiformat: JPEG, GIF oder PNG, max. Dateigröße 4 MB.',
    imageShapeDescription:
      'Für optimale Ergebnisse empfehlen wir ein quadratisches Bild mit transparentem Hintergrund mit einer Größe von mindestens 400 x 400 Px.',
    noFile: 'Keine Datei ausgewählt',
    companyDescription: 'Firmen-Beschreibung',
    myTestEdit: 'Meine Testbearbeitung',
    customerWelcomeEmail: 'E-Mail-Begrüßungstext für Kunden',
    testEditMessage: 'E-Mail-Text der Testbearbeitung',
    companyDescriptionTooltip:
      'Der hier eingegebene Text erscheint in den öffentlichen Ansichten der von Ihrem Unternehmen installierten Systeme. Sie können Kontaktdaten anfügen, um leichter Leads von Besuchern dieser Seiten zu erhalten.',
    editCompanyInformation: 'Angaben zum Unternehmen bearbeiten',
    welcomeEmailDescription:
      'Der hier eingegebene Text erscheint in der Begrüßungs-E-Mail, die an neue Kunden nach der Einrichtung eines Enlighten Kontos versendet wird. Sie können in dieser Nachricht Ihr Firmenlogo einfügen.',
    editWelcomeMessage: 'E-Mail-Begrüßungstext für Kunden bearbeiten',
    checkboxDisplayLogo: 'Anzeigen des Firmenlogos in der Begrüßungs-E-Mail für Kunden',
    previewEmail: 'Vorschau der Begrüßungs-E-Mail an Kunden',
    contactDetails: 'Kontaktdetails',
    streetAddress: 'Adresse',
    streetAddress2: 'Adresse 2',
    city: 'Stadt',
    zipCode: 'Postleitzahl',
    customerSupport: 'Kundendienstkontakte',
    country: 'Land',
    state: 'Bundesland',
    contactOwnerDescription: 'als Kontakt für Systembetreiber / Hausbesitzer ',
    businessContacts: 'Geschäftskontakte',
    sameCheckbox: 'Gleich wie Kundenbetreuung',
    contactEnphaseDescription: 'für Kontakt durch Enphase',
    installationDetails: 'Installationsdetails',
    servicesOffered: 'Angebotene Dienstleistungen',
    installationType: 'Art der Installation',
    salesEmployeeNumber: 'Anzahl der Mitarbeiter im Vertrieb',
    workmanshipWarranty: 'Angebotene Garantien auf Arbeitsleistungen (Jahr)',
    installationEmployeeNumber: 'Anzahl der Mitarbeiter, die Installationen durchführen',
    typicalInstallationsYear: 'Durchschnittliche Anzahl der Installationen (pro Jahr)',
    typicalInstallationsMonth: 'Durchschnittliches Volumen an Installationen (kW gesamt/ Monat)',
    enphaseShare: 'Anteil Enphase an Installationen',
    sgipDeveloper: 'Sind Sie ein SGIP-Entwickler?',
    sgipDeveloperTooltip:
      'Markieren Sie diese Option, wenn Sie bei selfgenca.com als SGIP-Entwickler registriert sind.',
    fein_ein: 'FEIN/EIN',
    sgipDeveloperKey: 'SGIP-Entwicklerschlüssel',
    businessLicenses: 'Geschäftslizenzen',
    addNewLicense: 'NEUE LIZENZ HINZUFÜGEN',
    licenseType: 'Lizenztyp',
    licenseNo: 'Lizenz-Nr.',
    none: 'Keine',
    licensingBoard: 'Lizenzierungsgremium',
    licensingAuthority: 'Genehmigungsbehörde',
    expiryDate: 'Verfallsdatum',
    profileLinks: 'Profil-Links',
    yelpAccountLink: 'Yelp-Konto-Link',
    rating: 'Bewertung: ',
    reviews: 'Beurteilungen: ',
    yelpAccountLinkTooltip:
      'Um diesen Link zu erhalten, öffnen Sie Ihr Yelp-Profil und kopieren Sie den Link/URL in die Adressleiste Ihres Internetbrowsers.',
    yelpAccountLinkError:
      'Leider konnten wir Ihr Yelp-Profil nicht abrufen. Überprüfen Sie den von Ihnen eingegebenen Profil-Link.',
    googlePlaceId: 'Google Place ID',
    clickHere: 'Klicken Sie hier,',
    findPlaceId: 'um Ihre Google Place ID zu suchen.',
    placeIdError:
      'Wir konnten keinen gültigen Ort für diese ID finden. Bitte überprüfen Sie die von Ihnen eingegebene ID erneut.',
    solarProfileLink: 'SolarReviews Profil-Link',
    solarProfileLinkTooltip:
      'Um diesen Link zu erhalten, öffnen Sie Ihr Profil bei SolarReviews.com und kopieren Sie den Link/URL in die Adressleiste Ihres Internetbrowsers.',
    bbbProfileLink: 'BBB Profil-Link',
    bbbProfileLinkTooltip:
      'Um diesen Link zu erhalten, öffnen Sie Ihr Profil bei BBB.org und kopieren Sie den Link/URL in die Adressleiste Ihres Internetbrowsers.',
    solarQuotesProfileLink: 'Solarquotes Profil-Link',
    solarQuotesTooltip:
      'Um diesen Link zu erhalten, öffnen Sie Ihr Profil bei solarquotes.com.au und kopieren Sie den Link/URL in die Adressleiste Ihres Internetbrowsers.',
    productReviewProfileLink: 'ProductReview Profil-Link',
    productReviewTooltip:
      'Um diesen Link zu erhalten, öffnen Sie Ihr Profil bei productreview.com.au und kopieren Sie den Link/URL in die Adressleiste Ihres Internetbrowsers.',
    trustPilotLink: 'Trustpilot-Profillink',
    trustPilotTooltip:
      'Um diesen Link zu erhalten, gehen Sie zu Ihrem trustpilot.com-Profil und kopieren Sie den Link/die URL in die Adressleiste Ihres Internetbrowsers',
    facebookLink: 'Facebook Profil Link',
    facebookTooltip:
      'Um diesen Link zu erhalten, gehen Sie zu Ihrem facebook.com-Profil und kopieren Sie den Link/die URL in die Adressleiste Ihres Internetbrowsers',
    justDialLink: 'Wählen Sie einfach den Profillink',
    justDialTooltip:
      'Um diesen Link zu erhalten, gehen Sie zu Ihrem justdial.com-Profil und kopieren Sie den Link/die URL in die Adressleiste Ihres Internetbrowsers',
    listOfReferenceSystems: 'Referenzanlagen-Liste',
    referenceListDescription:
      'Ihre Referenzliste wird automatisch aktualisiert, um Systeme zu präsentieren, die von ihren Eigentümern freigegeben wurden. Die gezeigten Systeme müssen mindestens 100 kWh Energie produziert haben.',
    requestSystemAccess: 'Systemzugriff anfordern',
    maintainer: 'Instandhalter',
    view_only: 'Nur Ansicht',
    linkRequestAccess: 'Senden Sie diesen Link an Systembetreiber, um in Enlighten Zugriff auf ihr System zu erhalten.',
    fieldRequired: 'Dieses Feld ist ein Pflichtfeld.',
    validEmail: 'Geben bitte Sie eine gültige E-Mail-Adresse ein.',
    validPhone: 'Geben Sie bitte eine gültige Telefonnummer ein.',
    supportContact: 'Füllen Sie bitte mindestens eines der obenstehenden Felder (Telefon/E-Mail) aus.',
    serviceRequired: 'Mindestens ein Servicetyp ist erforderlich.',
    installationRequired: 'Mindestens eine Art der Installation ist erforderlich.',
    minLength: 'Die Länge muss mindestens 2 betragen.',
    maxLength: 'Die Länge darf nicht mehr als 15 betragen.',
    dateWarning: 'Achtung: Diese Lizenz wird als abgelaufen erachtet, weil das Ablaufdatum in der Vergangenheit liegt.',
    correctValue: 'Der von Ihnen eingegebene Wert darf nicht größer sein als\xa0',
    feinLength: 'Geben Sie bitte ein 9-stellige Nummer ein.',
    less_than_25: 'Weniger als 25 %',
    between_25_50: '25 bis 50 %',
    between_50_90: '50 bis 90 %',
    greater_than_90: 'Mehr als 90 %',
    roofing: 'Dachdeckung',
    solar: 'Photovoltaik',
    storage: 'Speicher',
    electrical: 'Elektrik',
    ev_charger: 'EV-Ladegerät',
    others: 'Sonstige',
    commercial: 'Gewerblich',
    residential: 'Eigenheim',
    new_homes: 'Neubau',
    installer: 'Installateur',
    roles_distributor: 'Vertriebspartner',
    roles_support: 'Supportunternehmen',
    cec: 'CEC',
    electrical_contract: 'Stromvertrag',
    abn_number: 'ABN-Nummer',
    acn_number: 'ACN-Nummer',
    installateurverzeichniss_elektro_eintrag: 'Installateurverzeichniss Elektro Eintrag',
    sgze: 'SGZE',
    zonnekeur: 'Zonnekeur',
    holland_solar: 'Holland Solar',
    techniek_nederland: 'Techniek Nederland',
    installq: 'InstallQ',
    fedelec: 'Fedelec',
    pv_vlaanderen: 'PV Vlaanderen',
    selectCountry: 'Bitte wählen Sie ein Land',
    yellowPageLink: 'Link zur Gelben Seite',
    yellowPageTooltip: `Um diesen Link zu erhalten, gehen Sie zu Ihrem Profil https://www.pagesjaunes.fr/ und kopieren Sie den Link / die URL in die Adressleiste Ihres Internetbrowsers.`,
    enrQualityDirectoryLink: 'Jährliche Qualit’Enr',
    enrQualityDirectoryTooltip: `Um diesen Link zu erhalten, gehen Sie zu Ihrem Profil https://www.qualit-enr.org/annuaire/ und kopieren Sie den Link / die URL in die Adressleiste Ihres Internetbrowsers.`,
    validChamberNumber: 'Ungültige Eingabe! Für die Handelskammernummer sind mindestens 8 Zeichen erforderlich',
    chamberofcommerce : 'Nummer der Handelskammer',
  }
};

export default company;
